













































































import { Component, Vue } from "vue-property-decorator";
import DadosComplementoComplemento from "@/components/dados/DadosComplementoComplemento.vue";
import axios from 'axios';
import { mask } from "vue-the-mask";
import { directives } from 'vuetify/lib';

@Component({
    components: {
        DadosComplementoComplemento,
    },
    directives: {
        mask,
    },
})

export default class Endereco extends Vue {
    public cepMask = "#####-###";

    public data = "";
    public messageCep = "";
    public result = false;

    get cep () {
        return this.$store.state.endereco.cep;
    }

    set cep ( value ) {
        this.$store.commit("SET_CEP", value);
    }

    get cidade_uf () {
        return this.$store.state.endereco.cidade_uf;
    }

    set cidade_uf ( value ) {
        this.$store.commit("SET_CIDADE_UF", value);
    }

    get bairro () {
        return this.$store.state.endereco.bairro;
    }

    set bairro ( value ) {
        this.$store.commit("SET_BAIRRO", value);
    }
    get logradouro () {
        return this.$store.state.endereco.logradouro;
    }

    set logradouro ( value ) {
        this.$store.commit("SET_LOGRADOURO", value);
    }
     get complemento () {
        return this.$store.state.endereco.complemento;
    }

    set complemento ( value ) {
        this.$store.commit("SET_COMPLEMENTO", value);
    }

    public searchCep () {
			if(this.cep.length == 9) {
				axios.get(`https://viacep.com.br/ws/${ this.cep }/json/`)
                .then( response => {

                    this.logradouro = response.data.logradouro,
                    this.bairro = response.data.bairro,
                    this.complemento = response.data.complemento,
                    this.cidade_uf = response.data.localidade.concat(' - ', response.data.uf),
                    this.result = true;

                })
				.catch( error => console.log(error) )
			}
		}

    get errorCep () {
        return this.$store.state.errors.cep;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
 
    public onClick () {
           
                this.$router.push({
                  name: 'resumo'
                });


    }
}
